import script from "./Factors.vue?vue&type=script&setup=true&lang=js"
export * from "./Factors.vue?vue&type=script&setup=true&lang=js"

import "./Factors.vue?vue&type=style&index=0&id=8aa94882&lang=scss"

const __exports__ = script;

export default __exports__